import { Box, Icon, Text } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import {
  trackingNuvemDomainsManualConfigClick,
  trackingNuvemDomainsStartBuyClick,
} from 'domains/Configurations/Domains/tracking';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { DomainModalStep } from '../types';

interface AddDomainOptionsProps {
  onChangeStep: (step: DomainModalStep) => void;
  onClose: () => void;
  onOpenAddExistingDomain?: () => void;
}

export function AddDomainOptions({
  onChangeStep,
  onClose,
  onOpenAddExistingDomain,
}: Readonly<AddDomainOptionsProps>) {
  const t = useTranslationConfigurations('domains.landing');

  const handleSearchNewDomain = () => {
    trackingNuvemDomainsStartBuyClick();
    onChangeStep('searchNewDomain');
  };

  const handleAddExistingDomain = () => {
    if (onOpenAddExistingDomain) {
      trackingNuvemDomainsManualConfigClick();
      onClose();
      onOpenAddExistingDomain();
    }
  };

  return (
    <DataList>
      <DataList.Row onClick={handleSearchNewDomain}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          cursor="pointer"
        >
          <Box display="flex" flexDirection="column" gap="1">
            <Text fontSize="base" color="neutral-textHigh">
              {t('addDomainModal.options.searchNew.title')}
            </Text>
            <Text fontSize="caption" color="neutral-textLow">
              {t('addDomainModal.options.searchNew.subtitle')}
            </Text>
          </Box>
          <Icon source={<ChevronRightIcon />} color="primary-interactive" />
        </Box>
      </DataList.Row>
      <DataList.Row onClick={handleAddExistingDomain}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          cursor="pointer"
        >
          <Box display="flex" flexDirection="column" gap="1">
            <Text fontSize="base" color="neutral-textHigh">
              {t('addDomainModal.options.addExisting.title')}
            </Text>
            <Text fontSize="caption" color="neutral-textLow">
              {t('addDomainModal.options.addExisting.subtitle')}
            </Text>
          </Box>
          <Icon source={<ChevronRightIcon />} color="primary-interactive" />
        </Box>
      </DataList.Row>
    </DataList>
  );
}
